export interface Chapter {
  id: string;
  title: string;
  number: number;
  updatedAt: string;
}

export interface Comic {
  id: string;
  title: string;
  slug: string;
  cover: string;
  coverLarge: string;
  description: string;
  longDescription: string;
  category: string;
  categoryName: string;
  author: string;
  artist: string;
  status: "连载中" | "已完结" | "停更";
  rating: number;
  views: number;
  favorites: number;
  tags: string[];
  chapters: Chapter[];
  createdAt: string;
  updatedAt: string;
  featured?: boolean;
}

export const comics: Comic[] = [
  {
    id: "comic-1",
    title: "星辰魔法学院",
    slug: "star-magic-academy",
    cover: "https://readdy.ai/api/search-image?query=A%20manga-style%20cover%20illustration%20of%20a%20magical%20academy%20with%20a%20young%20student%20casting%20star-shaped%20spells%2C%20floating%20crystals%20and%20ancient%20towers%20in%20background%2C%20warm%20golden%20and%20crimson%20color%20scheme%2C%20detailed%20anime%20art%20style%2C%20dramatic%20lighting%2C%20rich%20fantasy%20atmosphere&width=400&height=560&seq=comic-cover-01&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20banner%20illustration%20of%20a%20grand%20magical%20academy%20campus%20with%20floating%20towers%20and%20students%20flying%20on%20broomsticks%2C%20starlit%20sky%2C%20golden%20magical%20energy%20flowing%20everywhere%2C%20detailed%20anime%20art%2C%20warm%20atmospheric%20lighting&width=1200&height=600&seq=comic-banner-01&orientation=landscape",
    description: "普通少年林星尘意外收到星辰魔法学院的录取通知书，从此踏入了一个充满魔法与奇迹的世界。在这里，他将结识志同道合的伙伴，面对古老预言的挑战，揭开学院深处隐藏的千年秘密。",
    longDescription: "在一个平凡的夏夜，十六岁的林星尘收到了一封用星光书写的信件——那是星辰魔法学院的录取通知书。从此，他的世界彻底改变了。在这座漂浮于云端的古老学院中，他不仅学会了操控星辰之力的魔法，更结识了来自四方的伙伴：冷静睿智的冰系法师苏寒、活泼开朗的风系少女叶灵儿、以及神秘寡言的黑魔法天才墨渊。然而，学院深处隐藏着一个千年预言：当七星连珠之时，被选中的星辰之子将面临光明与黑暗的终极抉择。随着古老封印的松动，林星尘发现自己与这个预言有着千丝万缕的联系……",
    category: "magic",
    categoryName: "魔法漫画",
    author: "星野千寻",
    artist: "墨染青衫",
    status: "连载中",
    rating: 9.6,
    views: 1280000,
    favorites: 58000,
    tags: ["魔法学院", "星辰之力", "青春热血", "命运对决", "友情"],
    chapters: [
      { id: "ch-1-1", title: "第1话 星光来信", number: 1, updatedAt: "2026-07-28" },
      { id: "ch-1-2", title: "第2话 入学试炼", number: 2, updatedAt: "2026-07-21" },
      { id: "ch-1-3", title: "第3话 元素觉醒", number: 3, updatedAt: "2026-07-14" },
      { id: "ch-1-4", title: "第4话 禁忌图书馆", number: 4, updatedAt: "2026-07-07" },
      { id: "ch-1-5", title: "第5话 星夜对决", number: 5, updatedAt: "2026-06-30" },
      { id: "ch-1-6", title: "第6话 预言之子", number: 6, updatedAt: "2026-06-23" },
      { id: "ch-1-7", title: "第7话 暗影来袭", number: 7, updatedAt: "2026-06-16" },
      { id: "ch-1-8", title: "第8话 守护之誓", number: 8, updatedAt: "2026-06-09" },
    ],
    createdAt: "2026-01-15",
    updatedAt: "2026-07-28",
    featured: true,
  },
  {
    id: "comic-2",
    title: "异能觉醒：零度领域",
    slug: "zero-domain-awakening",
    cover: "https://readdy.ai/api/search-image?query=A%20manga%20cover%20showing%20a%20teenage%20boy%20with%20ice%20powers%20emanating%20from%20his%20hands%20in%20a%20modern%20city%20setting%2C%20frozen%20particles%20floating%20in%20air%2C%20cool%20blue-white%20color%20palette%2C%20intense%20anime%20action%20style%2C%20dramatic%20urban%20background&width=400&height=560&seq=comic-cover-02&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20banner%20of%20a%20futuristic%20city%20half-frozen%20in%20ice%20with%20a%20lone%20figure%20standing%20in%20the%20center%2C%20ice%20crystals%20floating%20everywhere%2C%20dramatic%20blue%20and%20white%20lighting%2C%20detailed%20anime%20art%20style%2C%20post-apocalyptic%20atmosphere&width=1200&height=600&seq=comic-banner-02&orientation=landscape",
    description: "在不远的未来，一场神秘的基因突变让少数人类觉醒了异能。高中生白凛偶然发现自己拥有操控温度的能力，从此被卷入异能者与普通人类之间的暗流涌动之中。",
    longDescription: "公元2089年，一场被称为「觉醒日」的事件改变了世界——极少数人类开始展现出超自然能力。政府成立了「异能管理局」来监控和管制这些觉醒者。十六岁的白凛一直以为自己是再普通不过的高中生，直到那个酷热的夏日午后，他无意识地将整个教室冻结成了冰窟。他的能力被管理局发现后，被迫加入了一支由年轻异能者组成的特殊小队。在这里，他遇见了能读心的少女夏萤、操控金属的铁拳少年铁铮，以及身份成谜的队长夜澜。然而，在一次次任务中，白凛逐渐发现，管理局背后隐藏着一个足以改变人类命运的惊天秘密……",
    category: "superpower",
    categoryName: "异能漫画",
    author: "寒江独钓",
    artist: "冰河世纪",
    status: "连载中",
    rating: 9.4,
    views: 960000,
    favorites: 42000,
    tags: ["异能觉醒", "近未来", "超能力", "秘密组织", "热血战斗"],
    chapters: [
      { id: "ch-2-1", title: "第1话 觉醒之日", number: 1, updatedAt: "2026-07-26" },
      { id: "ch-2-2", title: "第2话 绝对零度", number: 2, updatedAt: "2026-07-19" },
      { id: "ch-2-3", title: "第3话 管理局", number: 3, updatedAt: "2026-07-12" },
      { id: "ch-2-4", title: "第4话 异能小队", number: 4, updatedAt: "2026-07-05" },
      { id: "ch-2-5", title: "第5话 首次任务", number: 5, updatedAt: "2026-06-28" },
      { id: "ch-2-6", title: "第6话 读心者的秘密", number: 6, updatedAt: "2026-06-21" },
    ],
    createdAt: "2026-02-20",
    updatedAt: "2026-07-26",
    featured: true,
  },
  {
    id: "comic-3",
    title: "龙之王座",
    slug: "dragon-throne",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20depicting%20a%20majestic%20dragon%20and%20a%20knight%20facing%20each%20other%20on%20a%20mountain%20peak%2C%20ancient%20ruins%20and%20kingdoms%20below%2C%20warm%20golden%20sunset%20lighting%2C%20epic%20high%20fantasy%20art%20style%2C%20rich%20detail&width=400&height=560&seq=comic-cover-03&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20epic%20fantasy%20illustration%20of%20a%20medieval%20kingdom%20with%20dragons%20soaring%20above%20a%20castle%2C%20armies%20gathered%20on%20the%20battlefield%2C%20dramatic%20stormy%20sky%20with%20sunbeams%20breaking%20through%2C%20detailed%20anime%20art%2C%20grand%20scale&width=1200&height=600&seq=comic-banner-03&orientation=landscape",
    description: "在龙与人类共存的艾泽拉大陆，一位被放逐的王子踏上了寻找失落龙族契约的征程。他必须唤醒沉睡的远古巨龙，夺回属于自己的王座。",
    longDescription: "艾泽拉大陆，一个龙与人类曾经和平共处的世界。三百年前，龙族在一场背叛中遭到重创，被迫退隐到大陆尽头的龙脊山脉。人类王国则在战后分裂为七国，彼此征战不休。年轻的王子艾德温·艾泽拉，在父王被篡位者杀害后，带着王室最后的遗物——一枚龙族契约徽章，踏上了流亡之路。传说在龙脊山脉的最深处，还沉睡着一头远古巨龙，只有真正的王者才能将它唤醒。艾德温必须穿越危机四伏的荒野，躲避追杀者的追捕，找到传说中的龙巢，与巨龙签订契约。这不仅是一场夺回王座的征程，更是一段关于勇气、信任与成长的奇幻史诗。",
    category: "fantasy",
    categoryName: "奇幻漫画",
    author: "龙吟九天",
    artist: "烽火戏诸侯",
    status: "已完结",
    rating: 9.8,
    views: 2150000,
    favorites: 89000,
    tags: ["西方奇幻", "巨龙", "王国争霸", "契约", "史诗冒险"],
    chapters: [
      { id: "ch-3-1", title: "第1话 亡国之日", number: 1, updatedAt: "2025-12-01" },
      { id: "ch-3-2", title: "第2话 流亡之路", number: 2, updatedAt: "2025-11-24" },
      { id: "ch-3-3", title: "第3话 荒野求生", number: 3, updatedAt: "2025-11-17" },
      { id: "ch-3-4", title: "第4话 佣兵之城", number: 4, updatedAt: "2025-11-10" },
      { id: "ch-3-5", title: "第5话 龙脊山脉", number: 5, updatedAt: "2025-11-03" },
      { id: "ch-3-6", title: "第6话 远古龙巢", number: 6, updatedAt: "2025-10-27" },
      { id: "ch-3-7", title: "第7话 契约之刻", number: 7, updatedAt: "2025-10-20" },
      { id: "ch-3-8", title: "第8话 王者归来", number: 8, updatedAt: "2025-10-13" },
      { id: "ch-3-9", title: "第9话 七国联军", number: 9, updatedAt: "2025-10-06" },
      { id: "ch-3-10", title: "第10话 最终决战", number: 10, updatedAt: "2025-09-29" },
      { id: "ch-3-11", title: "第11话 新纪元（大结局）", number: 11, updatedAt: "2025-09-22" },
    ],
    createdAt: "2025-03-10",
    updatedAt: "2025-12-01",
    featured: true,
  },
  {
    id: "comic-4",
    title: "修仙模拟器",
    slug: "cultivation-simulator",
    cover: "https://readdy.ai/api/search-image?query=A%20manga%20cover%20showing%20a%20young%20cultivator%20meditating%20on%20a%20floating%20sword%20above%20clouds%2C%20ancient%20Chinese%20temples%20and%20mountains%20in%20background%2C%20flowing%20spiritual%20energy%20like%20golden%20mist%2C%20xianxia%20anime%20art%20style%2C%20serene%20yet%20powerful%20atmosphere&width=400&height=560&seq=comic-cover-04&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20a%20heavenly%20realm%20with%20floating%20islands%20and%20ancient%20palaces%2C%20cultivators%20riding%20on%20swords%2C%20golden%20dragons%20in%20the%20clouds%2C%20magnificent%20xianxia%20aesthetic%2C%20detailed%20Chinese%20ink%20painting%20style%20blended%20with%20anime&width=1200&height=600&seq=comic-banner-04&orientation=landscape",
    description: "游戏宅陈凡意外穿越到修仙世界，却发现自己带着一个「修仙模拟器」系统。炼丹、炼器、阵法、功法——一切皆可模拟推演，从此他走上了与众不同的修仙之路。",
    longDescription: "资深游戏玩家陈凡在通宵打完一款修仙游戏后，一觉醒来发现自己穿越到了真正的修仙世界。更神奇的是，他的脑海中多了一个「修仙模拟器」系统——可以模拟推演任何功法的修炼路线、丹药的炼制过程、甚至是与敌人的战斗结果。在这个弱肉强食的修真界，别人苦修百年才能突破的境界，陈凡通过模拟器找到了最优路线；别人冒着爆体风险尝试的丹方，陈凡早已在模拟中验证过无数次。然而，随着修为的提升，他逐渐发现这个修仙世界的背后，隐藏着一个和「模拟器」密切相关的惊天秘密。原来，他并非第一个拥有模拟器的穿越者……",
    category: "xuanhuan",
    categoryName: "玄幻漫画",
    author: "码字机器猫",
    artist: "云中仙鹤",
    status: "连载中",
    rating: 9.3,
    views: 1850000,
    favorites: 76000,
    tags: ["穿越", "系统流", "修仙", "轻松搞笑", "扮猪吃虎"],
    chapters: [
      { id: "ch-4-1", title: "第1话 穿越修仙界", number: 1, updatedAt: "2026-08-01" },
      { id: "ch-4-2", title: "第2话 模拟器初体验", number: 2, updatedAt: "2026-07-25" },
      { id: "ch-4-3", title: "第3话 筑基丹方", number: 3, updatedAt: "2026-07-18" },
      { id: "ch-4-4", title: "第4话 宗门大比", number: 4, updatedAt: "2026-07-11" },
      { id: "ch-4-5", title: "第5话 秘境探索", number: 5, updatedAt: "2026-07-04" },
      { id: "ch-4-6", title: "第6话 元婴之谜", number: 6, updatedAt: "2026-06-27" },
      { id: "ch-4-7", title: "第7话 上古遗迹", number: 7, updatedAt: "2026-06-20" },
    ],
    createdAt: "2026-03-05",
    updatedAt: "2026-08-01",
    featured: false,
  },
  {
    id: "comic-5",
    title: "魔女之夜",
    slug: "witch-night",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manga%20cover%20with%20a%20beautiful%20witch%20holding%20a%20glowing%20crystal%20ball%20under%20a%20full%20moon%2C%20mysterious%20forest%20and%20floating%20candles%20around%20her%2C%20gothic%20atmosphere%2C%20rich%20purple%20and%20gold%20color%20palette%2C%20detailed%20anime%20art&width=400&height=560&seq=comic-cover-05&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20dark%20fantasy%20illustration%20of%20a%20witch%20coven%20gathering%20in%20an%20ancient%20forest%20under%20moonlight%2C%20floating%20spell%20circles%20and%20mystical%20symbols%2C%20ancient%20stone%20altar%2C%20ethereal%20atmosphere%2C%20detailed%20anime%20art%20style%2C%20mysterious%20and%20beautiful&width=1200&height=600&seq=comic-banner-05&orientation=landscape",
    description: "十六岁的少女莉莉丝在十六岁生日那天的月圆之夜，发现自己继承了家族传承千年的魔女之力。从此，她必须在白天扮演普通高中生，夜晚则化身守护城市的神秘魔女。",
    longDescription: "莉莉丝·布莱克伍德一直以为自己的家族只是一个有些古怪的古老家族——直到她十六岁生日那天。当满月升至中天，她感觉到一股强大的魔力从体内苏醒。原来，布莱克伍德家族是最后一批守护人类世界的魔女世家，而莉莉丝是预言中的「月之魔女」。白天，她是普通的高中生，和朋友逛街、担心考试；夜晚，她披上魔法斗篷，与潜伏在城市阴影中的黑暗生物作战。在她的冒险中，她遇到了同为魔女后裔的伙伴们：掌控火焰的炽、能与动物沟通的森、以及来历不明的神秘少年夜。然而，一个古老的邪恶正在苏醒，它将威胁到整个城市的安危……",
    category: "magic",
    categoryName: "魔法漫画",
    author: "月光蝶",
    artist: "暗夜精灵",
    status: "连载中",
    rating: 9.5,
    views: 720000,
    favorites: 31000,
    tags: ["魔女", "双重身份", "现代魔法", "青春成长", "暗黑奇幻"],
    chapters: [
      { id: "ch-5-1", title: "第1话 月圆之夜", number: 1, updatedAt: "2026-07-30" },
      { id: "ch-5-2", title: "第2话 暗影初现", number: 2, updatedAt: "2026-07-23" },
      { id: "ch-5-3", title: "第3话 魔女聚会", number: 3, updatedAt: "2026-07-16" },
      { id: "ch-5-4", title: "第4话 镜中世界", number: 4, updatedAt: "2026-07-09" },
      { id: "ch-5-5", title: "第5话 宿敌登场", number: 5, updatedAt: "2026-07-02" },
    ],
    createdAt: "2026-04-12",
    updatedAt: "2026-07-30",
    featured: false,
  },
  {
    id: "comic-6",
    title: "永恒之剑",
    slug: "eternal-blade",
    cover: "https://readdy.ai/api/search-image?query=A%20fantasy%20manga%20cover%20showing%20a%20lone%20swordsman%20holding%20a%20glowing%20legendary%20sword%20in%20a%20desolate%20battlefield%2C%20ancient%20ruins%20and%20broken%20weapons%20scattered%2C%20golden%20dawn%20light%20breaking%20through%20dark%20clouds%2C%20epic%20anime%20art%20style&width=400&height=560&seq=comic-cover-06&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20epic%20illustration%20of%20an%20ancient%20battlefield%20at%20dawn%20with%20a%20single%20warrior%20standing%20victorious%2C%20thousands%20of%20swords%20planted%20in%20the%20ground%2C%20dramatic%20sky%20with%20golden%20light%2C%20detailed%20anime%20art%2C%20legendary%20atmosphere&width=1200&height=600&seq=comic-banner-06&orientation=landscape",
    description: "铸剑师阿铁耗尽毕生心血，铸造了一把传说中的永恒之剑。然而，这把剑引来了各方势力的觊觎。为了保护这把绝世神兵，他的徒弟踏上了逃亡与复仇之路。",
    longDescription: "在大陆最北端的铁炉城中，住着一位被称为「神匠」的铸剑师——阿铁。他用了一生的时间，收集了陨铁之心、龙息之焰、以及人鱼之泪，铸造出了一把传说中的神兵：永恒之剑。这把剑拥有斩断一切的力量，甚至可以切开时空。然而，剑成之日，消息不胫而走。来自各国的势力纷纷派出高手，想要夺取这把剑。在混乱中，阿铁为了保护徒弟云飞而牺牲。临死前，他将永恒之剑交给了云飞，并嘱咐他找到剑的「真正主人」。云飞带着师父的遗愿，踏上了充满艰险的旅程。一路上，他不断成长，从胆小的铁匠学徒蜕变为独当一面的剑客……",
    category: "adventure",
    categoryName: "冒险漫画",
    author: "铁血丹心",
    artist: "剑指苍穹",
    status: "连载中",
    rating: 9.2,
    views: 860000,
    favorites: 38000,
    tags: ["冒险", "铸剑", "复仇", "成长", "武侠玄幻"],
    chapters: [
      { id: "ch-6-1", title: "第1话 神匠", number: 1, updatedAt: "2026-07-29" },
      { id: "ch-6-2", title: "第2话 剑成", number: 2, updatedAt: "2026-07-22" },
      { id: "ch-6-3", title: "第3话 血夜", number: 3, updatedAt: "2026-07-15" },
      { id: "ch-6-4", title: "第4话 启程", number: 4, updatedAt: "2026-07-08" },
      { id: "ch-6-5", title: "第5话 沙海迷踪", number: 5, updatedAt: "2026-07-01" },
      { id: "ch-6-6", title: "第6话 剑客镇", number: 6, updatedAt: "2026-06-24" },
    ],
    createdAt: "2026-02-28",
    updatedAt: "2026-07-29",
    featured: false,
  },
  {
    id: "comic-7",
    title: "都市捉妖师",
    slug: "urban-demon-hunter",
    cover: "https://readdy.ai/api/search-image?query=A%20modern%20urban%20fantasy%20manga%20cover%20showing%20a%20young%20man%20in%20a%20hoodie%20holding%20a%20spiritual%20talisman%20in%20a%20neon-lit%20city%20alley%2C%20ghostly%20figures%20lurking%20in%20shadows%2C%20contrast%20between%20modern%20and%20supernatural%2C%20detailed%20anime%20art&width=400&height=560&seq=comic-cover-07&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20a%20neon-lit%20modern%20city%20at%20night%20with%20supernatural%20elements%20hidden%20in%20plain%20sight%2C%20spirit%20creatures%20blending%20with%20crowds%2C%20ancient%20talismans%20glowing%20on%20buildings%2C%20urban%20fantasy%20anime%20style%2C%20mysterious%20atmosphere&width=1200&height=600&seq=comic-banner-07&orientation=landscape",
    description: "在这个妖怪与人类共存的时代，有一群不为人知的守护者——都市捉妖师。大学生江小鱼意外开启了阴阳眼，从此被卷入了一个光怪陆离的妖怪世界。",
    longDescription: "二十一世纪的都市丛林中，妖怪早已学会了伪装成人类，混迹于市井之间。而维持着人妖平衡的，是世代传承的「都市捉妖师」。江小鱼，一个普普通通的大学生，在某天深夜的便利店打工时，意外撞见了一只正在偷吃关东煮的狐妖。这次偶遇唤醒了他体内沉睡的阴阳眼血脉。从此，他的生活彻底改变——他加入了由一群奇葩捉妖师组成的「妖怪管理事务所」。这里有整天摸鱼的懒散道士张天师、武力值爆表的前黑帮大小姐铁拳玫瑰、以及一只自称是上古神兽的肥橘猫。在一次次捉妖任务中，江小鱼逐渐揭开了自己身世的秘密……",
    category: "urban",
    categoryName: "都市异能",
    author: "夜半钟声",
    artist: "水墨江南",
    status: "连载中",
    rating: 9.1,
    views: 650000,
    favorites: 28000,
    tags: ["都市奇幻", "妖怪", "搞笑", "阴阳眼", "事务所"],
    chapters: [
      { id: "ch-7-1", title: "第1话 便利店之夜", number: 1, updatedAt: "2026-07-31" },
      { id: "ch-7-2", title: "第2话 狐妖打工记", number: 2, updatedAt: "2026-07-24" },
      { id: "ch-7-3", title: "第3话 阴阳眼觉醒", number: 3, updatedAt: "2026-07-17" },
      { id: "ch-7-4", title: "第4话 妖怪事务所", number: 4, updatedAt: "2026-07-10" },
    ],
    createdAt: "2026-05-08",
    updatedAt: "2026-07-31",
    featured: false,
  },
  {
    id: "comic-8",
    title: "精灵之森",
    slug: "elf-forest",
    cover: "https://readdy.ai/api/search-image?query=A%20beautiful%20fantasy%20manga%20cover%20of%20an%20elf%20girl%20with%20long%20silver%20hair%20in%20an%20enchanted%20forest%2C%20glowing%20mushrooms%20and%20fireflies%2C%20ancient%20tree%20with%20magical%20runes%2C%20soft%20ethereal%20lighting%2C%20detailed%20anime%20art%2C%20dreamy%20atmosphere&width=400&height=560&seq=comic-cover-08&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20a%20mystical%20elf%20village%20hidden%20deep%20in%20an%20ancient%20forest%2C%20treehouses%20connected%20by%20rope%20bridges%2C%20waterfalls%20and%20crystal%20clear%20streams%2C%20magical%20creatures%2C%20ethereal%20light%2C%20detailed%20fantasy%20anime%20art&width=1200&height=600&seq=comic-banner-08&orientation=landscape",
    description: "人类少女艾琳在森林中迷路后，被精灵族收养。十二年后，她成为了精灵之森的守护者，但当人类的铁蹄踏入森林时，她必须在两个世界之间做出抉择。",
    longDescription: "十二年前，年幼的艾琳在与父母旅行时，在一场暴风雨中迷失在了禁忌之森。精灵女王发现了这个奄奄一息的人类女孩，出于怜悯将她带回了精灵族。在接下来的岁月里，艾琳在精灵之森中成长，学会了精灵的语言、弓箭术和自然魔法。她成为了精灵族的守护者，与森林中的万物生灵建立了深厚的羁绊。然而，和平在人类王国发现森林深处蕴藏着稀有魔晶后被打破。人类的军队开始向精灵之森进发。艾琳发现自己被夹在两个世界之间：一边是养育她的精灵族，另一边是她血脉相连的人类同胞。战争一触即发，而艾琳是唯一可能阻止这场浩劫的人……",
    category: "fantasy",
    categoryName: "奇幻漫画",
    author: "林间清风",
    artist: "碧落黄泉",
    status: "已完结",
    rating: 9.7,
    views: 1560000,
    favorites: 62000,
    tags: ["精灵", "人类与异族", "自然魔法", "身份认同", "史诗战争"],
    chapters: [
      { id: "ch-8-1", title: "第1话 迷失森林", number: 1, updatedAt: "2025-08-15" },
      { id: "ch-8-2", title: "第2话 精灵女王", number: 2, updatedAt: "2025-08-08" },
      { id: "ch-8-3", title: "第3话 弓箭术修行", number: 3, updatedAt: "2025-08-01" },
      { id: "ch-8-4", title: "第4话 十二年之后", number: 4, updatedAt: "2025-07-25" },
      { id: "ch-8-5", title: "第5话 人类的足迹", number: 5, updatedAt: "2025-07-18" },
      { id: "ch-8-6", title: "第6话 两难抉择", number: 6, updatedAt: "2025-07-11" },
      { id: "ch-8-7", title: "第7话 和平之路", number: 7, updatedAt: "2025-07-04" },
      { id: "ch-8-8", title: "第8话 新纪元（大结局）", number: 8, updatedAt: "2025-06-27" },
    ],
    createdAt: "2025-04-20",
    updatedAt: "2025-08-15",
    featured: false,
  },
  {
    id: "comic-9",
    title: "念力无双",
    slug: "telekinetic-unrivaled",
    cover: "https://readdy.ai/api/search-image?query=A%20manga%20cover%20showing%20a%20teenage%20girl%20with%20objects%20floating%20around%20her%20through%20telekinesis%20in%20a%20school%20setting%2C%20lockers%20and%20books%20suspended%20in%20mid-air%2C%20intense%20expression%2C%20dramatic%20anime%20art%20style%2C%20dynamic%20composition&width=400&height=560&seq=comic-cover-09&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20a%20school%20campus%20in%20chaos%20with%20students%20displaying%20various%20psychic%20powers%2C%20floating%20debris%2C%20energy%20clashes%2C%20dramatic%20lighting%2C%20detailed%20anime%20action%20style%2C%20intense%20atmosphere&width=1200&height=600&seq=comic-banner-09&orientation=landscape",
    description: "在一所专门培养异能者的特殊学校里，念力系新生苏念从最弱的F级开始，凭借过人的智慧和惊人的成长速度，一步步登上了异能者的巅峰。",
    longDescription: "天启学院，一所不为世人所知的特殊学校，专门培养觉醒了超能力的学生。在这里，学生们按照异能等级被分为S到F六个级别。苏念，一个来自普通家庭的女孩，在入学测试中被评定为最低的F级——她的念力只能移动一张纸。然而，没有人知道她拥有一个不为人知的秘密：她的念力并非弱小，而是极其精密的「微观念力操控」。通过不断磨练，她能够以念力操控分子、细胞，甚至改变物质的结构。从默默无闻的F级垫底生，到震惊全校的传奇学姐，苏念用自己的方式证明了：真正的强大，不在于力量的多少，而在于如何运用。",
    category: "superpower",
    categoryName: "异能漫画",
    author: "一念成空",
    artist: "风之幻想",
    status: "连载中",
    rating: 9.0,
    views: 580000,
    favorites: 25000,
    tags: ["学院", "等级制", "念力", "逆袭", "热血成长"],
    chapters: [
      { id: "ch-9-1", title: "第1话 F级新生", number: 1, updatedAt: "2026-07-27" },
      { id: "ch-9-2", title: "第2话 微观念力", number: 2, updatedAt: "2026-07-20" },
      { id: "ch-9-3", title: "第3话 第一次实战", number: 3, updatedAt: "2026-07-13" },
      { id: "ch-9-4", title: "第4话 学院排名战", number: 4, updatedAt: "2026-07-06" },
      { id: "ch-9-5", title: "第5话 震惊全场", number: 5, updatedAt: "2026-06-29" },
    ],
    createdAt: "2026-04-01",
    updatedAt: "2026-07-27",
    featured: false,
  },
  {
    id: "comic-10",
    title: "九幽录",
    slug: "nine-nether-records",
    cover: "https://readdy.ai/api/search-image?query=A%20dark%20xianxia%20manga%20cover%20depicting%20a%20cultivator%20standing%20at%20the%20edge%20of%20an%20abyss%2C%20dark%20energy%20swirling%2C%20ancient%20demonic%20symbols%20floating%2C%20mysterious%20and%20forbidding%20atmosphere%2C%20detailed%20Chinese%20ink%20anime%20style%2C%20dramatic%20contrast&width=400&height=560&seq=comic-cover-10&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20a%20dark%20underworld%20realm%20with%20twisted%20landscapes%2C%20ancient%20demonic%20palaces%2C%20rivers%20of%20lava%2C%20and%20ghostly%20figures%2C%20dark%20xianxia%20aesthetic%2C%20detailed%20anime%20art%2C%20epic%20and%20menacing%20atmosphere&width=1200&height=600&seq=comic-banner-10&orientation=landscape",
    description: "修仙界第一天才楚渊渡劫失败，堕入九幽深渊。在绝境之中，他发现了上古魔道传承，从此走上了一条亦正亦邪的逆天之路。",
    longDescription: "楚渊，灵霄宗千年不遇的修炼天才，年仅二十便已踏入元婴境界。然而，在天劫降临之时，他被同门暗算，渡劫失败，真身坠入了传说中的九幽深渊。九幽深渊是修仙界的禁地，传说其中封印着上古时期的魔道大能。所有人都以为楚渊必死无疑。但楚渊非但没有死，反而在深渊底部发现了一座古老的魔道传承遗迹。在这里，他接触到了与正道完全不同的修炼体系——魔道功法。为了复仇，也为了追求更强的力量，楚渊开始同时修炼正魔两道。当他重返修仙界之时，将掀起一场前所未有的风暴……",
    category: "xuanhuan",
    categoryName: "玄幻漫画",
    author: "黑暗左手",
    artist: "幽冥公子",
    status: "连载中",
    rating: 9.5,
    views: 1120000,
    favorites: 48000,
    tags: ["仙侠", "魔道", "逆袭", "复仇", "亦正亦邪"],
    chapters: [
      { id: "ch-10-1", title: "第1话 天才陨落", number: 1, updatedAt: "2026-08-02" },
      { id: "ch-10-2", title: "第2话 九幽深渊", number: 2, updatedAt: "2026-07-26" },
      { id: "ch-10-3", title: "第3话 魔道传承", number: 3, updatedAt: "2026-07-19" },
      { id: "ch-10-4", title: "第4话 正魔双修", number: 4, updatedAt: "2026-07-12" },
      { id: "ch-10-5", title: "第5话 破渊而出", number: 5, updatedAt: "2026-07-05" },
      { id: "ch-10-6", title: "第6话 重返灵霄", number: 6, updatedAt: "2026-06-28" },
    ],
    createdAt: "2026-03-20",
    updatedAt: "2026-08-02",
    featured: false,
  },
  {
    id: "comic-11",
    title: "时空旅人的笔记",
    slug: "time-traveler-notes",
    cover: "https://readdy.ai/api/search-image?query=A%20manga%20cover%20showing%20a%20young%20time%20traveler%20holding%20a%20glowing%20pocket%20watch%2C%20clock%20gears%20and%20different%20time%20periods%20swirling%20around%2C%20steampunk%20elements%2C%20mysterious%20atmosphere%2C%20detailed%20anime%20art%2C%20warm%20golden%20lighting&width=400&height=560&seq=comic-cover-11&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20time%20portals%20opening%20to%20different%20eras%2C%20dinosaurs%20and%20futuristic%20cities%20visible%20through%20portals%2C%20a%20lone%20traveler%20with%20a%20magical%20watch%2C%20steampunk%20and%20fantasy%20blend%2C%20detailed%20anime%20art%2C%20epic%20scale&width=1200&height=600&seq=comic-banner-11&orientation=landscape",
    description: "大学生周远获得了一本能够穿越时空的神秘笔记。每当他在笔记上写下某个时间和地点，就会被传送到那个时空。然而，每一次穿越都在微妙地改变着现实……",
    longDescription: "周远是个普通的历史系大学生，直到他在学校图书馆的角落里发现了一本泛黄的古旧笔记。笔记的封面上写着：「时间的记录者」。出于好奇，他在笔记上随意写下了一个日期——1945年8月6日，广岛。下一秒，他发现自己站在了那个历史性的时刻。他惊慌失措地逃离，但回到现代后却发现，历史课本上多了一段他从未学过的记载。原来，每一次穿越都在改写现实。周远开始谨慎地使用这本笔记，探索不同的时代，结识历史中的人物。但他很快发现，有另一群「时空守护者」在追踪他——他们的使命是阻止任何人改变时间线。而他最大的发现是：这本笔记的前任主人，正是他的曾祖父，而曾祖父的失踪与这本笔记有着千丝万缕的联系……",
    category: "adventure",
    categoryName: "冒险漫画",
    author: "时光旅人",
    artist: "笔落惊风",
    status: "连载中",
    rating: 9.6,
    views: 920000,
    favorites: 41000,
    tags: ["时空穿越", "历史", "蝴蝶效应", "冒险", "悬疑"],
    chapters: [
      { id: "ch-11-1", title: "第1话 图书馆的发现", number: 1, updatedAt: "2026-07-30" },
      { id: "ch-11-2", title: "第2话 第一次穿越", number: 2, updatedAt: "2026-07-23" },
      { id: "ch-11-3", title: "第3话 蝴蝶效应", number: 3, updatedAt: "2026-07-16" },
      { id: "ch-11-4", title: "第4话 时空守护者", number: 4, updatedAt: "2026-07-09" },
      { id: "ch-11-5", title: "第5话 曾祖父的秘密", number: 5, updatedAt: "2026-07-02" },
    ],
    createdAt: "2026-04-25",
    updatedAt: "2026-07-30",
    featured: false,
  },
  {
    id: "comic-12",
    title: "隐世高手在校园",
    slug: "hidden-master-campus",
    cover: "https://readdy.ai/api/search-image?query=A%20manga%20cover%20of%20a%20seemingly%20ordinary%20high%20school%20student%20with%20a%20hidden%20powerful%20aura%2C%20martial%20arts%20energy%20subtly%20visible%2C%20school%20buildings%20in%20background%2C%20contrast%20between%20ordinary%20and%20extraordinary%2C%20detailed%20anime%20art&width=400&height=560&seq=comic-cover-12&orientation=portrait",
    coverLarge: "https://readdy.ai/api/search-image?query=A%20wide%20illustration%20of%20a%20modern%20school%20campus%20with%20subtle%20supernatural%20elements%2C%20students%20walking%20unaware%20of%20hidden%20masters%20among%20them%2C%20cherry%20blossoms%2C%20warm%20afternoon%20light%2C%20detailed%20anime%20art%2C%20slice-of-life%20feel&width=1200&height=600&seq=comic-banner-12&orientation=landscape",
    description: "修真界第一高手林风厌倦了打打杀杀，决定隐姓埋名去体验普通高中生活。然而，树欲静而风不止，各路麻烦总是自己找上门来。",
    longDescription: "修真界有个传说：天下第一高手「风剑仙」在某一天突然消失了，没有人知道他去了哪里。事实上，他只是厌倦了无休止的争斗，决定去体验一下传说中的「普通学生生活」。于是，修真界第一剑仙林风化名「林小风」，以转学生的身份进入了滨海市第一高中。他本想过上看看书、写写作业、交交朋友的平静日子。然而计划赶不上变化——同桌是个隐藏的妖族公主，班主任是退隐的修真前辈，就连校园里闹鬼的传说都是真的。而更大的麻烦是，修真界的仇家们似乎也找到了他的踪迹……",
    category: "urban",
    categoryName: "都市异能",
    author: "闲云野鹤",
    artist: "笑红尘",
    status: "连载中",
    rating: 9.3,
    views: 1380000,
    favorites: 55000,
    tags: ["修真", "校园", "扮猪吃虎", "搞笑", "日常"],
    chapters: [
      { id: "ch-12-1", title: "第1话 转校生", number: 1, updatedAt: "2026-08-03" },
      { id: "ch-12-2", title: "第2话 同桌是妖族", number: 2, updatedAt: "2026-07-27" },
      { id: "ch-12-3", title: "第3话 校园怪谈", number: 3, updatedAt: "2026-07-20" },
      { id: "ch-12-4", title: "第4话 班主任的秘密", number: 4, updatedAt: "2026-07-13" },
      { id: "ch-12-5", title: "第5话 旧敌来寻", number: 5, updatedAt: "2026-07-06" },
      { id: "ch-12-6", title: "第6话 校园武道会", number: 6, updatedAt: "2026-06-29" },
      { id: "ch-12-7", title: "第7话 身份暴露", number: 7, updatedAt: "2026-06-22" },
    ],
    createdAt: "2026-05-15",
    updatedAt: "2026-08-03",
    featured: false,
  },
];

export const featuredComics = comics.filter(c => c.featured);

export const getComicBySlug = (slug: string): Comic | undefined => {
  return comics.find(c => c.slug === slug);
};

export const getComicsByCategory = (categorySlug: string): Comic[] => {
  return comics.filter(c => c.category === categorySlug);
};

export const getPopularComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => b.views - a.views).slice(0, limit);
};

export const getNewestComics = (limit: number = 8): Comic[] => {
  return [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, limit);
};